// import React from 'react';
import styled from 'styled-components';

export const ButtonPanel = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  margin: 30px 0px;
  @media(max-width: 800px) {
    display: block;
    > div { width: 100%; margin-bottom: 10px; text-align: center; }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Calculators/ButtonPanel.js